import script from "./AppBurgerMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBurgerMenu.vue?vue&type=script&setup=true&lang=js"

import "./AppBurgerMenu.vue?vue&type=style&index=0&id=17944de9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17944de9"]])

export default __exports__